export const API_ROUTES = {
  deliveries: "/deliveries",
  errorNotifications: "/error-notifications",
  files: "/files",
  labs: "/labs",
  orderLines: "/order-lines",
  orderResponses: "/order-responses",
  orders: "/orders",
  patients: "/patients",
  priceLists: "/price-lists",
  prices: "/prices",
  supplierInvoices: "/supplier-invoices",
  users: "/users",
  vatCodes: "/vat-codes",
};

export const QUERY_PARAMS = {
  orderResponseId: "lab_dental_lab_order_response_id",
  orderId: "lab_dental_lab_order_id",
};

export const APP_ROUTES = {
  orders: "/app/dashboard/orders",
};
